<template>
  <main class="page pto">
    <AppPageHeader title="Журнал изменений" />

    <section class="section page__content">
      <FilterPtoChangelog
        @request="loadFilter"
        @reset="loadFilter"
      />

      <TableVuex
        namespaced="pto/changelog"
        :has-checkbox="false"
      />
    </section>

    <PaginationVuex namespaced="pto/changelog" />
  </main>
</template>

<script>
import AppPageHeader from '@/components/page/AppPageHeader'
import FilterPtoChangelog from '@/components/pto/filter/FilterPtoChangelog'
import PaginationVuex from '@/components/page/pagination/PaginationVuex'
import { mapActions, mapMutations } from 'vuex'
import TableVuex from '@/components/page/table/TableVuex'

export default {
  name: 'PtoChangelog',
  components: {
    TableVuex,
    PaginationVuex,
    FilterPtoChangelog,
    AppPageHeader
  },
  async mounted () {
    await Promise.all([
      this.loadList(),
      this.GETChangelogObjectList()
    ])
  },
  destroyed () {
    this.RESET_STORE()
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETChangelogObjectList: 'GETChangelogObjectList'
    }),
    ...mapMutations('pto/changelog', {
      RESET_STORE: 'RESET_STORE'
    }),

    ...mapActions('pto/changelog', {
      loadList: 'loadList',
      loadFilter: 'loadFilter'
    })
  }
}
</script>
